export const SET_SIGNALS = 'SET_SIGNALS'
export const ADD_SHOWN_SIGNAL = 'ADD_SHOWN_SIGNAL'
export const CLEAR_SIGNALS = 'CLEAR_SIGNALS'
